import { API_URL } from './api';
import { isKitIcon, withKitIconVersion } from '../constants/pictograms';

/** Built-in kit icons live on the frontend. Uploads come from the API. */
export function mediaSrc(url?: string | null) {
  if (!url) return '';
  if (isKitIcon(url)) {
    return withKitIconVersion(url);
  }
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `${API_URL}${url}`;
}
